import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {IExpenseState, initialExpensesState} from "./Helper";
import {createExpense, deleteExpense, getExpenses, updateExpense} from "./ActionCreators";
import {IExpense} from "../../api/expenseService";

const initialValue: IExpenseState = {
    items: initialExpensesState,
    fetchExpensesLoading: false,
    actionLoading: false,
    fetchExpensesRequestId: undefined,
}

const expenseSlice = createSlice({
    name: SliceNames.EXPENSE,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getExpenses.pending, (state, action) => {
                state.fetchExpensesLoading = true
                state.fetchExpensesRequestId = action.meta.requestId
            })
            .addCase(
                getExpenses.fulfilled, (state, action) => {
                    if (state.fetchExpensesRequestId !== action.meta.requestId) {
                        return
                    }
                    state.items = action.payload
                    state.fetchExpensesLoading = false
                    state.fetchExpensesRequestId = undefined
                })
            .addCase(
                getExpenses.rejected, (state, action) => {
                    if (state.fetchExpensesRequestId !== action.meta.requestId) {
                        return
                    }
                    state.fetchExpensesLoading = false
                    state.fetchExpensesRequestId = undefined
                })
            .addCase(
                createExpense.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createExpense.fulfilled, (state, action: PayloadAction<IExpense>) => {
                    state.items = {
                        count: state.items.count + 1,
                        total_pages: state.items.total_pages,
                        data: [action.payload, ...state.items.data]
                    }
                    state.actionLoading = false
                })
            .addCase(
                createExpense.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                updateExpense.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                updateExpense.fulfilled, (state, action: PayloadAction<IExpense>) => {
                    state.items = {
                        ...state.items,
                        data: state.items.data.map((item) => (
                            item.id === action.payload.id ? action.payload : item
                        ))
                    }
                    state.actionLoading = false
                })
            .addCase(
                updateExpense.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                deleteExpense.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                deleteExpense.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = {
                        count: Math.max(state.items.count - 1, 0),
                        total_pages: state.items.total_pages,
                        data: state.items.data.filter((item) => item.id !== action.payload)
                    }
                    state.actionLoading = false
                })
            .addCase(
                deleteExpense.rejected, (state) => {
                    state.actionLoading = false
                })
    }
})

export default expenseSlice.reducer
